const remarkData = [
    {
        content: '动画和互动游戏都很吸引小朋友，之前也报过音基课感觉孩子都不是很喜欢，这个还不错！'
    },
    {
        content: '原来还能这样学，居然能听出孩子哪里唱高了唱低了，小朋友经常跟我炫耀他的得分！'
    },
    {
        content: '朋友推荐音乐壳，说音基效果不错，试了一下，孩子还真挺喜欢，学习效果也不错，老师好亲切也很专业。'
    },
    {
        content: '让孩子在家上这么优质的音基课真的太赞了，解决了我们这些上班族父母的痛点，足不出户节省了路途时间，还能自主掌握学习时段。'
    },
    {
        content: '音乐壳的题库效果非常好，有互动，孩子愿意一题一题做下去，吸收效果也好，相信孩子考试通关是没太大问题。'
    },
    {
        content: '不错，挺适合孩子的，我都跟着学会了，音乐常识的星球故事很有趣，我家孩子特喜欢模仿弗兰克。'
    },
    
    {
        content: '孩子正好在学钢琴，一边学习音乐壳里的音基课，发现近期更爱弹琴了，课程很有趣，为这样的平台点赞。'
    },
]
export { remarkData } 